import isString from 'lodash/isString';

export default defineNuxtPlugin((nuxtApp) => {
  const localePath = useLocalePath();

  const rewriteRootPath = (path) => {
    if (path === '__home__') return '/';
    return path.startsWith('/') ? path : '/' + path;
  };

  const localeRootPath = (route, locale = null) => {
    const args = [];
    if (!route) args[0] = route;
    else if (isString(route)) args[0] = rewriteRootPath(route);
    else if (route.path !== undefined) args[0] = { ...route, path: rewriteRootPath(route.path) };
    else args[0] = route;

    if (locale) args[1] = locale;
    return localePath(...args);
  };

  return {
    provide: {
      localeRootPath,
    },
  };
});
